// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__15PjQ","location":"Header_location__2L3T5"};